import React from "react";
import { Box, Flex, Image } from "@chakra-ui/react";
import { ColoredTag } from "../../common/ColoredTag";
import { TrackRecordModel } from "../../../api/models";
import { BuildingLineIcon } from "../../../icons";

export interface TrackRecordNameColumnRenderProps {
  record: TrackRecordModel;
  isView?: boolean;
}

export const TrackRecordNameColumnRender: React.FC<
  TrackRecordNameColumnRenderProps
> = ({ record, isView }) => {
  const [showFallback, setShowFallback] = React.useState(false);

  return (
    <Flex>
      <Box mr={2} pt={2}>
        {isView &&
          (!showFallback && record.imageUrl ? (
            <Image
              objectFit="cover"
              width="48px"
              height="48px"
              maxW={"48px"}
              borderRadius={4}
              src={record.imageUrl || ""}
              onError={() => setShowFallback(true)}
            />
          ) : (
            <Flex
              minW={"48px"}
              maxW={"48px"}
              h={"48px"}
              w={"100%"}
              backgroundColor={"bg.lighter"}
              borderRadius={4}
              alignItems={"center"}
              justifyContent={"center"}
            >
              <BuildingLineIcon boxSize={"24px"} />
            </Flex>
          ))}
      </Box>
      <Box>
        {record.opportunityTag && (
          <Flex mb={0.5}>
            <ColoredTag
              fontSize={"12px"}
              fontWeight="500"
              borderRadius={4}
              height={"auto"}
            >
              {record.opportunityTag.toUpperCase()}
            </ColoredTag>
          </Flex>
        )}
        <Box textStyle="bodySmallBold">{record.investmentName}</Box>
        <Box mt={0.5} textStyle="bodySmall" color={"text.grey"}>
          {record.investmentType}
        </Box>
      </Box>
    </Flex>
  );
};
